export const isToday = ({ date }) =>
  new Date().toDateString() === date.toDateString();
